import type { DynamicDropdownMap } from './dynamicDropdowns.types'

const MALFORMED_DYNAMIC_DROPDOWNS = 'Malformed dynamic dropdowns response'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function parseDynamicDropdownsResponse(value: unknown): DynamicDropdownMap {
  if (!isRecord(value)) throw new TypeError(MALFORMED_DYNAMIC_DROPDOWNS)
  const dimensions = value.dropdownable_dimensions
  if (!isRecord(dimensions)) throw new TypeError(MALFORMED_DYNAMIC_DROPDOWNS)

  const map: Record<string, readonly string[]> = {}
  for (const [dimension, values] of Object.entries(dimensions)) {
    if (!Array.isArray(values) || !values.every((item) => typeof item === 'string')) continue
    map[dimension] = [...(values as string[])]
  }
  return map
}
